import { motion } from "framer-motion";
import { CITY_SHOT_B } from "@/constants/assets";

function Shot({ src, alt, caption, sub, testid }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.7 }}
      className="relative overflow-hidden border-2 border-gb-line group h-[320px] lg:h-[560px]"
      data-testid={testid}
    >
      <img
        src={src}
        alt={alt}
        className="absolute inset-0 w-full h-full object-cover pixelated group-hover:scale-[1.03] transition-transform duration-700"
      />
      <div className="absolute inset-0 scanlines opacity-50" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-t from-gb-bg via-transparent to-transparent" />
      <div className="absolute top-3 left-3 w-4 h-4 border-t-2 border-l-2 border-gb-neon/80" />
      <div className="absolute top-3 right-3 w-4 h-4 border-t-2 border-r-2 border-gb-neon/80" />
      <div className="absolute bottom-0 inset-x-0 p-5">
        <p className="font-title text-2xl sm:text-3xl text-gb-pale">{caption}</p>
        <p className="text-[10px] tracking-[0.2em] text-gb-accent mt-1">{sub}</p>
      </div>
    </motion.div>
  );
}

export default function City() {
  return (
    <section id="city" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7 }}
          className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12"
        >
          <div>
            <p className="text-gb-neon text-[11px] tracking-[0.3em] mb-3">01 · THE FIRST CITY</p>
            <h2 className="font-title text-6xl sm:text-7xl lg:text-8xl uppercase text-gb-pale leading-[0.85]">
              Replicant City
            </h2>
          </div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-4 items-stretch">
          <Shot
            src={CITY_SHOT_B}
            alt="A neighbourhood of the Replicant City simulation"
            caption="A NEIGHBOURHOOD IN THE SIMULATION"
            sub="EVERY HOUSE, SHOP AND HOSPITAL EXISTS · WITH HOURS, STAFF AND CAPACITY"
            testid="city-shot-1"
          />
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="relative border-2 border-gb-line bg-gb-card p-8 sm:p-10 flex flex-col justify-center min-h-[300px] lg:h-auto"
            data-testid="city-description"
          >
            <div className="absolute top-3 left-3 w-4 h-4 border-t-2 border-l-2 border-gb-neon/80" />
            <div className="absolute bottom-3 right-3 w-4 h-4 border-b-2 border-r-2 border-gb-neon/80" />
            <p className="font-pixel text-xl text-gb-accent mb-5">$ city --readme</p>
            <p className="text-sm sm:text-base leading-relaxed text-gb-mint/90">
              One fictional American town:{" "}
              <span className="text-gb-neon">100 residents</span> in{" "}
              <span className="text-gb-neon">40 households</span> and{" "}
              <span className="text-gb-neon">68 buildings</span> with interiors,
              two districts joined only by a subway. The city runs in real time
              on a public server.
            </p>
            <p className="mt-5 text-sm leading-relaxed text-gb-light/85">
              Everything is declared in one scenario file: map, institutions
              and their hours, wages, prices, rent, an illness, four groups,
              daily weather and a catalogue of{" "}
              <span className="text-gb-neon">twelve interventions</span>, over
              a thirty-day span with no births, deaths or migration.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}